import toastACI from "components/toastACI";
import useStorage from "hooks/useStorage";
import client from "./client";
import commonHelper from "./commonHelper";

export const handleLocalStorageOnLogin = (
  responseLogin,
  ipAddress,
  isDiffUser,
  isContinue,
  isOnValidExam
) => {
  const { getItem, setItem, removeItem } = useStorage();

  if (isDiffUser) {
    removeItem("randomQuestionTemp");
    removeItem("randomAnswerTemp");
  }
  if (isDiffUser || isContinue || isOnValidExam) {
    removeItem("savedTimerInstruction");
    removeItem("subtest");
  }
  if (!isDiffUser && (isContinue || isOnValidExam)) {
    const lastSavedQuestion = getItem("savedQuestion");

    if (lastSavedQuestion) {
      setItem("lastSavedQuestion", lastSavedQuestion);
    }
  }
  if (responseLogin.data.participant.isProctoring) {
    localStorage.setItem("itoken", responseLogin.data.authenticate.iframeToken);
  } else {
    localStorage.removeItem("itoken");
  }

  removeItem("savedQuestion");
  removeItem("savedQuestionServer");
  removeItem("exam");
  removeItem("dataExam");
  removeItem("savedTimerExam");
  removeItem("lastTimeAutoSave");

  setItem("token", responseLogin.data.authenticate.accessToken);
  setItem("participant", { ...responseLogin.data.participant, ipAddress });
  setItem("isLogin", true);
};

export const handleCurrentSubtestOnLogin = async (
  res,
  isContinue,
  ipAddress,
  isNotifWelcome = false
) => {
  const { getItem, setItem } = useStorage();

  const lastParticipant = getItem("lastParticipant");
  const isDiffUser =
    lastParticipant?.participantId &&
    res.data.participant.participantId !== lastParticipant?.participantId;
  let currentSubtestIndex = -1;
  let isOnExam = false;

  if (res.data.authenticate.accessToken) {
    const resSubtest = await client.requestAPI({
      endpoint: `api/v1/exam-participants/${res.data.participant?.participantId}/exam-projects/${res.data.participant?.projectId}/exam-subtests`,
      isAuth: false,
      pToken: res.data.authenticate.accessToken,
    });
    if (resSubtest?.meta?.status === "Success" && resSubtest?.data?.length) {
      setItem("listSubtest", resSubtest.data);
      const currentSubtest = resSubtest?.data?.find((value, index) => {
        currentSubtestIndex = index;
        return !value?.isFinished;
      });
      isOnExam = currentSubtest?.subtestStartedOn || false;
    }
    const isOnValidExam = currentSubtestIndex >= 0 && isOnExam;

    if (isNotifWelcome) {
      commonHelper.toast.push(
        toastACI({
          type: "success",
          header: "Login Success",
          message: `You have successfully Logged In, Welcome back ${res.data.participant.participantName}!`,
        }),
        { placement: "topEnd" }
      );
    }

    handleLocalStorageOnLogin(res, ipAddress, isDiffUser, isContinue, isOnValidExam);
    commonHelper.navigate("/");
  }
};

export const getCaptchaStatus = async () => {
  try {
    const res = await client.requestAPI({
      endpoint: "api/v1/status-seb",
      isAuth: false,
    });
    if (res?.meta?.status === "Success") {
      return res?.data?.isCaptcha;
    }
  } catch (error) {
    console.error("Error get captcha status: ", error?.response?.data?.message || error?.message);
  }
  return true;
};
